import React from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import cls from 'classnames'
import Typography from '@material-ui/core/Typography'
import SubmitButton from '../../../../Components/Form/Button'
import { lighten, makeStyles } from '@material-ui/core/styles'

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: 0,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}))

const EnhancedTableToolbar = ({ numSelected, onSave = () => {}, title }) => {
  const styles = useToolbarStyles()

  return (
    <Toolbar
      className={cls(styles.root, {
        [styles.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={styles.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={styles.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
      )}

      {numSelected > 0 ? (
        <SubmitButton
          variant="contained"
          value="Make Payment"
          onClick={onSave}
        />
      ) : null}
    </Toolbar>
  )
}

export default EnhancedTableToolbar
